import { sendRequest } from '../../config';

export interface updateLocalizadorParams {
    /** parametros obligatorios */
    cpais: string;
    nlocaliza: string;

    /** parametros opcionales */
    iestado?: string;
}

export interface dataUpdateLocalizador {
    description: string;
}

export const updateLocalizador = async (params: updateLocalizadorParams[]): Promise<dataUpdateLocalizador> => {
    const ENDPOINT = 'wslocalizador/update';
    return sendRequest({
        method: 'post',
        path: ENDPOINT,
        body: params,
    });
};